var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"future-professions-grid"},[_c('h2',{staticClass:"title"},[_vm._v("Профессиональные навыки")]),_vm._v(" "),_c('div',{staticClass:"cards-wrapper"},_vm._l((_vm.futureProfessions),function(card){return _c('FutureProfessionsCard',{key:card.id,attrs:{"card":card}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }